import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@api/models/user.model';
import { map, Observable } from 'rxjs';
import { ShowResponse, IndexResponse } from '@api/models/response.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseService {
  constructor() {
    super('users');
  }

  getEmployees(page: number = 1, perPage: number = 50, q: string = '', filters: Record<string, string> = {}): Observable<IndexResponse<User>> {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });

    // Add search query if present
    if (q) {
      queryParams.append('q', q);
    }

    // Add all non-empty filters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });

    const municipalityId = this.appService.municipalityId();
    if (!municipalityId) {
      throw new Error('Geen gemeente geselecteerd');
    }

    return this.http.get<IndexResponse<User>>(
      `${this.apiUrl}?${queryParams.toString()}`,
      {
        headers: {
          'X-Municipality-Id': municipalityId,
        },
      }
    );
  }

  getEmployee(id: string): Observable<User> {
    return this.http.get<ShowResponse<User>>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() }).pipe(
      map((response) => response.data)
    );
  }

  createEmployee(employee: User): Observable<User> {
    return this.http.post<ShowResponse<User>>(`${this.apiUrl}`, employee, { headers: this.getHeaders() }).pipe(
      map((response) => response.data)
    );
  }

  updateEmployee(id: string, employee: User): Observable<User> {
    return this.http.put<ShowResponse<User>>(`${this.apiUrl}/${id}`, employee, { headers: this.getHeaders() }).pipe(
      map((response) => response.data)
    );
  }

  deleteEmployee(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { headers: this.getHeaders() });
  }

  resendInvite(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/resend-invite`, {}, { headers: this.getHeaders() });
  }

  reset2FA(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/reset-2fa`, {}, { headers: this.getHeaders() });
  }
}
